import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://oplyokhcmgwqyofynhxw.supabase.co';  // Replace with your Supabase URL
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9wbHlva2hjbWd3cXlvZnluaHh3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI3Mjc5NDcsImV4cCI6MjA2ODMwMzk0N30.3z1Gryf2oqyAXURLgvjUmM7JSgJnoq1AAcDzdaKyaQ4';  // Replace with your Supabase anon key

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
